import {
    Box,
    Typography,
    Grid
} from '@mui/material'
import Motorcycle1 from '../../../assets/motorcycle-financing/motorcycle1.png'
import Motorcycle2 from '../../../assets/motorcycle-financing/motorcycle2.png'
import Motorcycle3 from '../../../assets/motorcycle-financing/motorcycle3.png'
import Motorcycle4 from '../../../assets/motorcycle-financing/motorcycle4.png'
import { useTranslation } from 'react-i18next'

export const SMAppThougtSchemes: React.FC = () => {
    const { t } = useTranslation()

    const data = [
        {
            'backgroundImage': Motorcycle1,
            'title': t('t167'),
            'content': t('t168'),
            'data': [
                t('t169'),
                t('t170'),
                t('t171'),
            ]
        },
        {
            'backgroundImage': Motorcycle2,
            'title': t('t172'),
            'content': t('t173'),
            'data': [
                t('t174'),
                t('t175'),
                t('t176'),
            ]
        },
        {
            'backgroundImage': Motorcycle3,
            'title': t('t177'),
            'content': t('t178'),
            'data': [
                t('t179'),
                t('t180'),
                t('t181'),
            ]
        },
        {
            'backgroundImage': Motorcycle4,
            'title': t('t1811'),
            'content': '',
            'data': [
                t('t1812'),
                t('t1813'),
                t('t181'),
            ]
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingBottom: '24px',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center'
            }}>
                <Box sx={{
                    backgroundImage: `url(${data[index]['backgroundImage']})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'start',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '10px',
                }}>

                    <Box sx={{
                        width: '100%',
                        height: '100%',
                        paddingLeft: '21px',
                        paddingRight: '21px',
                        paddingTop: '180px',
                        display: 'flex'
                    }}>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '10px',
                            paddingLeft: '24px',
                            paddingRight: '24px',
                            paddingTop: '40px',
                            paddingBottom: '40px',
                            boxShadow: '0px 10px 80px 3px #0000001A',
                        }}>
                            <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                                {data[index]['title']}
                            </Typography>

                            <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'8px'}>
                                {data[index]['content']}
                            </Typography>

                            <Box sx={{ paddingTop: '8px' }}>
                                {data[index]['data'].map((subItem, subIndex) => (
                                    renderTitleItem(subItem, subIndex)
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }

    // const renderPadItem = (index: number) => {
    //     return (
    //         <Grid key={index} item xs={4}>
    //             <Box sx={{
    //                 width: '100%',
    //                 height: '100%',
    //                 backgroundImage: `url(${data[index]['backgroundImage']})`,
    //                 backgroundSize: 'contain',
    //                 backgroundPosition: 'start',
    //                 backgroundRepeat: 'no-repeat',
    //             }}>

    //                 <Box sx={{
    //                     width: '100%',
    //                     height: '100%',
    //                     paddingLeft: '21px',
    //                     paddingRight: '21px',
    //                     paddingTop: (window.innerWidth - 72)*0.02,
    //                     display: 'flex'
    //                 }}>
    //                     <Box sx={{
    //                         width: '100%',
    //                         height: '100%',
    //                         backgroundColor: '#FFFFFF',
    //                         borderRadius: '10px',
    //                         paddingLeft: '24px',
    //                         paddingRight: '24px',
    //                         paddingTop: '40px',
    //                         paddingBottom: '40px',
    //                         boxShadow: '0px 10px 80px 3px #0000001A',
    //                     }}>
    //                         <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
    //                             {data[index]['title']}
    //                         </Typography>

    //                         <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'8px'}>
    //                             {data[index]['content']}
    //                         </Typography>

    //                         <Box sx={{ paddingTop: '8px' }}>
    //                             {data[index]['data'].map((subItem, subIndex) => (
    //                                 renderTitleItem(subItem, subIndex)
    //                             ))}
    //                         </Box>
    //                     </Box>
    //                 </Box>
    //             </Box>
    //         </Grid>
    //     )
    // }

    const renderTitleItem = (item: string, index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '4px',
            }}>
                <Box sx={{
                    paddingTop: '7px',
                }}>
                    <Box sx={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '3px',
                        backgroundColor: '#6B6B6B'
                    }}></Box>
                </Box>
                <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'} paddingLeft={'8px'}>
                    {item}
                </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#FFFDF7',
                paddingTop: '16px',
            }}
        >

            {/* Our Carefully Thought Schemes */}
            <Box sx={{
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography fontSize={24} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                    {t('t165')}
                </Typography>
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} textAlign={'center'} paddingTop={'16px'}>
                    {t('t166')}
                </Typography>
            </Box>

            {/* Motorcycle */}
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '45px',
                paddingBottom: '20px',
            }}>
                {(data.map((item, index) => (
                    renderItem(index)
                )))}
            </Box>
        </Box >
    )
}

// ======================= EXPORT
export default SMAppThougtSchemes
